
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aUp3o", function(module, exports) {

$parcel$export(module.exports, "LivePagesChangeboardingManager", () => $4c89affce539688d$export$72c84db60c29d335);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

const $4c89affce539688d$var$LivePagesChangeboardingModalManagerLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "vcfPR",
    name: "LivePagesChangeboardingModalManagerLoader",
    loader: async ()=>(await (parcelRequire("7l6yL"))).LivePagesChangeboardingModalManager
});

const $4c89affce539688d$var$LivePagesExpandedEapChangeboardingSpotlightsLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uwSgm",
    name: "LivePagesExpandedEapChangeboardingSpotlightsLoader",
    loader: async ()=>{
        return (await (parcelRequire("8vHeP"))).LivePagesExpandedEapChangeboardingSpotlights;
    }
});

const $4c89affce539688d$var$LivePagesClosedBetaSpaceSettingsSpotlightLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "zeujZ",
    name: "LivePagesClosedBetaSpaceSettingsSpotlightLoader",
    loader: async ()=>{
        return (await (parcelRequire("kgh0U"))).LivePagesClosedBetaSpaceSettingsSpotlight;
    }
});
const $4c89affce539688d$var$originToComponentMap = {
    'view-page': $4c89affce539688d$var$LivePagesClosedBetaSpaceSettingsSpotlightLoader,
    'live-page': $4c89affce539688d$var$LivePagesExpandedEapChangeboardingSpotlightsLoader
};
const $4c89affce539688d$export$72c84db60c29d335 = ({ origin: origin })=>{
    const SpotlightComponent = $4c89affce539688d$var$originToComponentMap[origin];
    /*
   * The changeboarding modal and spotlights are independent messages, but
   * if a user hasn't seen either, they should see the modal first & then the spotlights
   */ const [changeboardingState, setChangeboardingState] = (0, $gwFzn.useState)('modal');
    return changeboardingState !== 'stopped' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, changeboardingState === 'modal' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4c89affce539688d$var$LivePagesChangeboardingModalManagerLoader, {
        onClose: ()=>setChangeboardingState('walkthrough')
    }), changeboardingState === 'walkthrough' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(SpotlightComponent, {
        onStop: ()=>setChangeboardingState('stopped')
    })) : null;
};

});
parcelRegister("7l6yL", function(module, exports) {

let $557f952be53e041e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $557f952be53e041e$var$load("joJy8"),
    $557f952be53e041e$var$load("aHE9G"),
    $557f952be53e041e$var$load("kKJbN")
]).then(()=>parcelRequire('bJrQM'));

});

parcelRegister("8vHeP", function(module, exports) {

let $6322c22af485ac96$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6322c22af485ac96$var$load("30tYm").then(()=>parcelRequire('d85iI'));

});

parcelRegister("kgh0U", function(module, exports) {

let $ec027fd3cce30736$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ec027fd3cce30736$var$load("konA4").then(()=>parcelRequire('lwMob'));

});



//# sourceMappingURL=LivePagesChangeboardingManager.c26ab985.js.map
